// Library methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Components
import CommentsList from "../CommentsList";
import Watermark from "../Watermark";
import { ErrorMessageComponent } from "../ErrorMessage";

// Utils
import { ReportDataContext } from "../../../contexts/ReportDataContext";
import { sectionCompletionState } from "../../../hooks/useExamStatus";
import { ReportEachSectionContext } from "../../../contexts/CommentContext";
import { examCardEnums, eyeTypes } from "../../../enums";

// This component is for visual acuity and contrast sensitivity
const EyeReportContent = (props) => {
  const { ReportInfo, ExamGraph } = props;

  const { eyeBoth } = eyeTypes;

  const { t } = useTranslation();
  const { exam } = useContext(ReportDataContext);
  const { examReport } = useContext(ReportEachSectionContext);

  // algorithm version number
  const algorithmVersion = examReport?.exam?.version?.substring(0, 3);
  const deviceVersion =
    examReport?.device?.version?.match(/\d+(\.\d+)*/)?.[0] ?? "N/A";

  const isTerminated = useMemo(() => {
    const enumValues = Object.values(examCardEnums);
    const sectionName = enumValues.find(
      (enumValue) => enumValue.type === examReport?.exam?.type
    )?.sectionName;

    if (!exam?.[sectionName]?.length) return false;

    const terminatedEyeSection = exam?.[sectionName]?.find(
      (section) =>
        (section.eye === examReport?.exam?.eye ||
          examReport?.exam?.eye === eyeBoth) &&
        section.completionState === sectionCompletionState.Terminated
    );

    return Boolean(terminatedEyeSection);
  }, [exam, examReport?.exam, eyeBoth]);

  // build the report content
  return (
    <>
      {ReportInfo}

      {examReport?.postProcessing ? (
        <>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ my: 5 }}
          >
            {isTerminated && <Watermark py={10} />}
            {ExamGraph}
          </Grid>
          <Grid container item xs={12} mt={2}>
            <CommentsList isVisualField={false} />
          </Grid>
          <Grid
            container
            item
            display="flex"
            xs={12}
            flexDirection="row"
            justifyContent={"end"}
            mt={2}
          >
            <Grid item xs={12}>
              <Typography textAlign={"right"}>
                {t("Algorithm Version")}: {algorithmVersion}
              </Typography>
              <Typography textAlign={"right"}>
                {t("device_app_version")}: {deviceVersion}
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <ErrorMessageComponent errorBit={1} />
      )}
    </>
  );
};

export default EyeReportContent;
